<template>
  <div>
    <MainLayout>
      <InboxList />
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout/index.vue';
import InboxList from '../components/inbox/InboxList.vue';

export default {
  components: {
    MainLayout,
    InboxList,
  },
};
</script>
